<template>
  <div class="wg-row">
    <wg-modal :simple="true" :width="'200px'" v-if="saving">
      <template slot="body">
        <div
          class="wg-row com-anm22-app-text-l"
          style="justify-content: center"
        >
          {{ $anm22.strLang(lang, "Saving...", "Salvataggio in corso...") }}
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div
          class="wg-row"
          style="align-items: center; justify-content: center"
        >
          <vue-simple-spinner
            size="medium"
            :line-fg-color="appColor"
          ></vue-simple-spinner>
        </div>
      </template>
    </wg-modal>
    <!-- Modale dati tessera -->
    <wg-modal
      v-if="showEditModal"
      :portal="true"
      :width="windowWidth > 499 ? '500px' : '90%'"
      @closeModal="showEditModal = false"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        {{
          editingCard.idWorldCard
            ? $anm22.strLang(lang, "Edit card", "Modifica tessera")
            : $anm22.strLang(lang, "New card", "Nuova tessera")
        }}
      </div>
      <div slot="body" class="wg-row">
        <form class="wg-row" method="POST" action="" @submit.prevent="saveCard">
          <div class="wg-row input-with-label" style="margin-bottom: 10px">
            <div class="label">
              {{ $anm22.strLang(lang, "Type", "Tipologia") }}
            </div>
            <select
              class="com-anm22-app-select"
              v-model="editingCard.cardType"
              required
            >
              <option
                v-for="(ct, i) in cardTypes"
                :key="'ct-' + i"
                :value="ct.idWorldCardType"
              >
                {{ ct.name }}
              </option>
            </select>
          </div>
          <div class="wg-row input-with-label" style="margin-bottom: 10px">
            <div class="label">
              {{ $anm22.strLang(lang, "First Name", "Nome") }}
            </div>
            <input type="text" v-model="editingCard.firstName" required />
          </div>
          <div class="wg-row input-with-label" style="margin-bottom: 10px">
            <div class="label">
              {{ $anm22.strLang(lang, "Last name", "Cognome") }}
            </div>
            <input type="text" v-model="editingCard.lastName" required />
          </div>
          <div class="wg-row input-with-label" style="margin-bottom: 10px">
            <div class="label">
              {{ $anm22.strLang(lang, "E-mail", "E-mail") }}
            </div>
            <input type="email" v-model="editingCard.email" />
          </div>
          <div class="wg-row input-with-label" style="margin-bottom: 10px">
            <div class="label">
              {{ $anm22.strLang(lang, "Phone", "Telefono") }}
            </div>
            <div class="wg-row" style="flex-wrap: nowrap; align-items: center">
              <select
                class="com-anm22-app-select"
                style="width: 80px; margin-right: 5px"
                v-model="editingCard.phoneAreaCode"
              >
                <option
                  v-for="(ac, i) in $anm22.tableClasses.areaCode().getAll()"
                  :key="'ac-' + i"
                  :value="ac.typeClassLiteral"
                >
                  {{ ac.typeClassLiteral }}
                </option>
              </select>
              <input type="number" v-model="editingCard.phoneNumber" />
            </div>
          </div>
          <div class="wg-row">
            <button class="small green">
              <div>{{ $anm22.strLang(lang, "Confirm", "Conferma") }}</div>
            </button>
            <button
              type="button"
              class="small"
              style="margin-left: 10px"
              @click="showEditModal = false"
            >
              <div>{{ $anm22.strLang(lang, "Cancel", "Annulla") }}</div>
            </button>
            <button
              type="button"
              class="small red"
              style="margin-left: auto"
              @click="deleteCard"
            >
              <div>{{ $anm22.strLang(lang, "Delete", "Cancella") }}</div>
            </button>
          </div>
        </form>
      </div>
    </wg-modal>
    <!-- Modale gestione tessera -->
    <wg-modal
      v-if="showCardModal"
      :portal="true"
      :width="windowWidth > 599 ? '600px' : '90%'"
      @closeModal="showCardModal = false"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        {{ $anm22.strLang(lang, "Manage card", "Gestisci tessera") }}
      </div>
      <div slot="body" class="wg-row" style="padding: 0 10px">
        <template v-if="cardModalPage === 'recap'">
          <!-- Immagine carta -->
          <div
            class="wg-row"
            style="justify-content: center; margin-bottom: 20px"
          >
            <div class="card-image">
              <img
                :src="$anm22.icons.getWorldIcon('edit')"
                class="btn"
                :title="$anm22.strLang(lang, 'Edit card', 'Modifica carta')"
                @click="editCard"
              />
              <img
                :src="
                  'https://www.anm22.it/app/pay/utilities/img/cards/' +
                  selectedCardType.cardImage
                "
                class="card-image"
              />
            </div>
          </div>
          <!-- Intestatario e saldo -->
          <div class="wg-row" style="justify-content: space-between">
            <div class="display-flex" style="flex-direction: column">
              <div class="com-anm22-app-text-xxl">
                {{ selectedCard.firstName + " " + selectedCard.lastName }}
              </div>
              <div
                v-if="selectedCard.email"
                class="com-anm22-app-text-l"
                style="color: #999"
              >
                {{ selectedCard.email }}
              </div>
              <div
                v-if="selectedCard.phoneNumber"
                class="com-anm22-app-text-l"
                style="color: #999"
              >
                {{
                  selectedCard.phoneAreaCode + " " + selectedCard.phoneNumber
                }}
              </div>
            </div>
            <div
              class="display-flex"
              style="flex-direction: column; text-align: right"
            >
              <div class="com-anm22-app-text-xxl">
                {{ $anm22.strLang(lang, "Balance", "Saldo") }}
              </div>
              <div class="com-anm22-app-text-xl" style="color: #999">
                {{ selectedCard.balance.toFixed(2) }}
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-horizontal-line-light"></div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <!-- Ricarica -->
          <div class="wg-row" style="justify-content: space-between">
            <input
              type="number"
              style="width: 100px; text-align: right"
              @focus="$event.target.select()"
              v-model="topUpAmount"
            />
            <button
              class="small blue"
              @click="openTopUpDialog"
            >
              <div>{{ $anm22.strLang(lang, "Top-up", "Ricarica") }}</div>
            </button>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-horizontal-line-light"></div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row"
            style="justify-content: center; margin-bottom: 10px"
          >
            <div class="com-anm22-app-text-xl">
              {{
                $anm22.strLang(lang, "Last transactions", "Ultimi movimenti")
              }}
            </div>
          </div>
          <div
            class="wg-row"
            style="justify-content: center; margin-bottom: 10px"
          >
            <div
              v-if="transactionsLoading"
              class="wg-row"
              style="margin: 10px; justify-content: center; margin-top: 10px"
            >
              <vue-simple-spinner size="medium" :line-fg-color="appColor" />
            </div>
            <template v-else>
              <div
                v-if="selectedCardTransactions.length === 0"
                class="com-anm22-app-text-l"
              >
                {{
                  $anm22.strLang(
                    lang,
                    "No movements found",
                    "Nessuna transazione"
                  )
                }}
              </div>
              <div v-else class="wg-row" style="height: 130px">
                <w-g-list
                  :sorting="false"
                  :fieldInit="'date'"
                  :keyField="'idWorldTransaction'"
                  :itemsToDisplay="
                    transactionsListItems
                      .sort((a, b) => b.date - a.date)
                      .slice(0, 5)
                  "
                >
                  <template v-slot:default="{ element, data }">
                    <div class="wg-row transaction">
                      <div class="wg-col wg-xs-5">
                        <div class="com-anm22-app-text-l">
                          {{
                            $moment
                              .tz(element.date, "X", timezone)
                              .format("L LT")
                          }}
                        </div>
                      </div>
                      <div class="wg-col wg-xs-5">
                        <div class="com-anm22-app-text-l">
                          {{ data.label }}
                        </div>
                      </div>
                      <div class="wg-col wg-xs-2" style="text-align: right">
                        <div class="com-anm22-app-text-l">
                          {{ element.amount.toFixed(2) }}
                        </div>
                      </div>
                    </div>
                  </template>
                </w-g-list>
              </div>
            </template>
          </div>
          <div class="wg-row" style="justify-content: center">
            <button class="small blue" @click="viewTransactions">
              <div>
                {{ $anm22.strLang(lang, "View all", "Visualizza tutte") }}
              </div>
            </button>
          </div>
        </template>
        <template v-else-if="cardModalPage === 'transactions'">
          <div
            class="wg-row"
            style="
              height: 36px;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              margin-bottom: 10px;
              position: relative;
            "
          >
            <button
              class="small blue"
              style="position: absolute; left: 0; top: 0"
              @click="cardModalPage = 'recap'"
            >
              <div>{{ $anm22.strLang(lang, "Back", "Indietro") }}</div>
            </button>
            <div class="com-anm22-app-text-xl">
              {{ $anm22.strLang(lang, "Transactions", "Transazioni") }}
            </div>
          </div>
          <div class="wg-row" style="height: 430px">
            <w-g-list
              :pagination="true"
              :fieldInit="'date'"
              :keyField="'idWorldTransaction'"
              :headerItems="transactionsListHeader"
              :itemsToDisplay="transactionsListItems"
            >
              <template v-slot:default="{ element, data }">
                <div class="wg-row transaction">
                  <div class="wg-col wg-xs-5">
                    <div class="com-anm22-app-text-l">
                      {{ $moment.unix(element.date).format("L LT") }}
                    </div>
                  </div>
                  <div class="wg-col wg-xs-5">
                    <div class="com-anm22-app-text-l">
                      {{ data.label }}
                    </div>
                  </div>
                  <div class="wg-col wg-xs-2" style="text-align: right">
                    <div class="com-anm22-app-text-l">
                      {{ element.amount.toFixed(2) }}
                    </div>
                  </div>
                </div>
              </template>
            </w-g-list>
          </div>
        </template>
      </div>
    </wg-modal>
    <!-- Modale conferma ricarica -->
    <wg-modal v-if="showConfirmTopUp" @closeModal="showConfirmTopUp = false">
      <div slot="body">
        <div class="wg-row" style="justify-content:center;text-align:center;margin: 20px 0">
          <div class="com-anm22-app-text-xxl">
            {{
              $anm22.strLang(
                lang,
                "Confirm " + this.topUpAmount + " credits top-up?",
                "Confermare ricarica di " + this.topUpAmount + " crediti?"
              )
            }}
          </div>
        </div>
        <div
          class="wg-row"
          style="
            flex-direction: column;
            align-items: center;
            align-content: stretch;
            margin-bottom: 20px;
          "
        >
          <div class="com-anm22-app-text-xl" style="margin-bottom: 10px">
            {{ $anm22.strLang(lang, "Payment method", "Metodo di pagamento") }}
          </div>
          <select
            class="com-anm22-app-select"
            style="width: 100px"
            v-model="topUpPm"
          >
            <option :value="1">
              {{ $anm22.strLang(lang, "Cash", "Contanti") }}
            </option>
            <option :value="3">
              {{ $anm22.strLang(lang, "Card", "Carta") }}
            </option>
          </select>
        </div>
        <div
          class="wg-row"
          style="
            flex-direction: column;
            align-items: center;
            align-content: stretch;
            margin-bottom: 20px;
          "
        >
          <div class="com-anm22-app-text-xl" style="margin-bottom: 10px">
            {{ $anm22.strLang(lang, "Price", "Prezzo applicato") }}
          </div>
          <div class="display-flex" style="flex-wrap:nowrap;align-items:center;">
            <input type="number" style="font-size:16px;width: 100px;text-align:right;" v-model="topUpPrice">
            <div class="com-anm22-app-text-l" style="margin-left: 5px;">€</div>
          </div>
        </div>
        <div
          class="wg-row"
          style="flex-wrap: nowrap; justify-content: space-around"
        >
          <div
            v-for="(printer, index) in printers"
            :key="'printer-fis-ticket-' + index"
            class="display-flex action-btn-with-desc"
          >
            <img
              :src="$anm22.icons.getWorldIcon('printf')"
              class="btn print-button-fis"
              :title="printer.name"
              @click="processTopUp(printer.idPrinter)"
            />
            <div class="vertical-height-div" style="height: 5px"></div>
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Fiscal", "Fiscale") }}
            </div>
            <div class="com-anm22-app-text-m">{{ printer.name }}</div>
          </div>
          <div class="display-flex action-btn-with-desc">
            <img
              :src="$anm22.icons.getWorldIcon('cash')"
              class="btn"
              :title="
                $anm22.strLang(
                  lang,
                  'Pay without printing',
                  'Paga senza stampa'
                )
              "
              @click="processTopUp(0)"
            />
            <div class="vertical-height-div" style="height: 5px"></div>
            <div class="com-anm22-app-text-m">
              {{
                $anm22.strLang(
                  lang,
                  "Pay without printing",
                  "Paga senza stampa"
                )
              }}
            </div>
          </div>
          <div class="display-flex action-btn-with-desc">
            <img
              :src="$anm22.icons.getWorldIcon('deleteRed')"
              class="btn"
              :title="$anm22.strLang(lang, 'Cancel', 'Annulla')"
              @click="showConfirmTopUp = false"
            />
            <div class="vertical-height-div" style="height: 5px"></div>
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Cancel", "Annulla") }}
            </div>
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Pulsante nuova tessera -->
    <div
      class="wg-row"
      style="
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
      "
    >
      <div class="display-flex" style="flex-wrap: nowrap; align-items: center">
        <div class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, "Cards", "Tessere") }}
        </div>
      </div>
      <button
        :disabled="!canEmit"
        class="small green"
        :style="!canEmit ? { opacity: '0.4', pointerEvents: 'none' } : ''"
        @click="initNewCard"
      >
        <img :src="$anm22.icons.getWorldIcon('add')" />
        <div>{{ $anm22.strLang(lang, "New", "Nuova") }}</div>
      </button>
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <!-- Lista con elenco carte -->
    <div
      v-if="loading"
      class="wg-row"
      style="margin: 10px; justify-content: center; margin-top: 10px"
    >
      <vue-simple-spinner size="medium" :line-fg-color="appColor" />
    </div>
    <div v-else class="wg-row" :style="{ height: listHeight + 'px' }">
      <w-g-list
        :pagination="true"
        :fieldInit="'number'"
        :keyField="'idWorldCard'"
        :clickFn="(card) => openCard(card)"
        :headerItems="cardListHeader"
        :itemsToDisplay="cardListItems"
      >
        <template v-slot:default="{ element, data }">
          <div :class="['wg-row', 'card-row']">
            <div class="wg-col wg-xs-2 wg-sm-2">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <img
                  v-if="element.balance < 0"
                  :src="$anm22.icons.getWorldIcon('warningRed')"
                  class="com-anm22-app-img-fixed-height-m"
                  style="margin-right: 5px"
                />
                <div class="com-anm22-app-text-l">
                  {{ element.number }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-none wg-sm-2">
              <div class="com-anm22-app-text-l">
                {{ data.cardType.name }}
              </div>
            </div>
            <div class="wg-col wg-xs-4 wg-sm-3">
              <div class="com-anm22-app-text-l">
                {{ element.name }}
              </div>
            </div>
            <div class="wg-col wg-xs-4 wg-sm-4">
              <div class="com-anm22-app-text-l">
                {{ element.email }}
              </div>
            </div>
            <div class="wg-col wg-xs-2 wg-sm-1">
              <div class="wg-row" style="justify-content: flex-end">
                <div class="com-anm22-app-text-l">
                  {{ $anm22.round(element.balance, 2).toFixed(2) }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import WGList from "../../../../../world/spa/components/WGList.vue";

export default {
  components: {
    "vue-simple-spinner": Spinner,
    WGList,
  },
  props: {
    permission: {
      type: Number,
      default: 6,
    },
    timezone: {
      type: String,
      default: "Europe/Rome",
    },
  },
  data() {
    return {
      loading: true,
      saving: false,
      // data from Pay
      cards: [],
      cardTypes: [],
      // new/edit card
      editingCard: {},
      showEditModal: false,
      // edit card
      transactionsLoading: false,
      selectedCard: null,
      selectedCardType: null,
      selectedCardTransactions: [],
      showCardModal: false,
      cardModalPage: "recap",
      // Top Up
      showConfirmTopUp: false,
      topUpAmount: 1,
      topUpPrice: 1, 
      topUpPm: 1,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      licenseSelected: (state) => state.licenseSelected,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
      isOffline: (state) => state.offline.isOffline,
      appColor: (state) => state.config.appColor,
    }),
    listHeight() {
      return this.windowHeight - (this.windowWidth > 767 ? 140 : 190);
    },
    license() {
      return this.$store.getters["foodLicenses/getByHash"](
        this.licenseSelected
      );
    },
    accessControl() {
      return this.$store.getters["foodAcs/get"](
        this.license.id + "-" + this.permission
      );
    },
    printers() {
      return this.$store.getters["foodPrinters/getByLicense"](
        this.license.id
      ).filter((p) => p.printMode.fis);
    },
    canEmit() {
      return this.cardTypes.length > 0;
    },
    cardListHeader() {
      return [
        {
          field: "number",
          label: this.$anm22.strLang(this.lang, "Number", "Numero"),
          class: "wg-xs-2 wg-sm-2",
          disabled: false,
        },
        {
          field: "cardType",
          label: this.$anm22.strLang(this.lang, "Type", "Tipologia"),
          class: "wg-xs-none wg-sm-2",
          disabled: false,
        },
        {
          field: "name",
          label: this.$anm22.strLang(this.lang, "Name", "Nome"),
          class: "wg-xs-4 wg-sm-3",
          disabled: false,
        },
        {
          field: "email",
          label: this.$anm22.strLang(this.lang, "E-mail", "E-mail"),
          class: "wg-xs-4 wg-sm-4",
          disabled: false,
        },
        {
          field: "balance",
          label: this.$anm22.strLang(this.lang, "Balance", "Saldo"),
          class: "wg-xs-2 wg-sm-1",
          style: { justifyContent: "flex-end" },
          disabled: false,
        },
      ];
    },
    cardListItems() {
      return this.cards.map((c) => {
        const cardType = this.cardTypes.find(
          (ct) => ct.idWorldCardType === c.cardType
        );
        return {
          ...c,
          name: c.firstName + " " + c.lastName,
          "list-metadata": {
            type: "item",
            cardType,
          },
        };
      });
    },
    transactionsListHeader() {
      return [
        {
          field: "date",
          label: this.$anm22.strLang(this.lang, "Date", "Data"),
          class: "wg-xs-5",
          disabled: false,
        },
        {
          field: "",
          label: this.$anm22.strLang(this.lang, "Type", "Tipo"),
          class: "wg-xs-5",
          disabled: true,
        },
        {
          field: "amount",
          label: this.$anm22.strLang(this.lang, "Amount", "Totale"),
          class: "wg-xs-2",
          disabled: false,
        },
      ];
    },
    transactionsListItems() {
      if (this.selectedCardTransactions) {
        return this.selectedCardTransactions.map((t) => {
          return {
            ...t,
            "list-metadata": {
              type: "item",
              label: t.senderCard
                ? this.$anm22.strLang(this.lang, "Payment", "Pagamento")
                : this.$anm22.strLang(this.lang, "Top-up", "Ricarica"),
            },
          };
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    initNewCard() {
      this.editingCard = {
        cardType: this.cardTypes[0].idWorldCardType,
        firstName: "",
        lastName: "",
        email: "",
        phoneAreaCode: "+39",
        phoneNumber: "",
      };
      // Open modal
      this.showEditModal = true;
    },
    editCard() {
      this.editingCard = {};
      Object.assign(this.editingCard, this.selectedCard);
      delete this.editingCard["list-metadata"];
      this.showEditModal = true;
    },
    async saveCard() {
      this.saving = true;
      const mode = this.editingCard.idWorldCard ? "edit" : "new";
      try {
        const response = await this.$http.post("settings/save-card", {
          card: this.editingCard,
        });
        if (mode === "edit") {
          const index = this.cards.findIndex(
            (c) => c.idWorldCard === this.editingCard.idWorldCard
          );
          this.cards[index] = response.data.card;
          this.selectedCard = this.cards[index];
        } else {
          this.cards.push(response.data.card);
        }
        this.saving = false;
        this.showEditModal = false;
      } catch (e) {}
    },
    async openCard(c) {
      this.selectedCard = c;
      this.showCardModal = true;
      this.selectedCardType = this.cardTypes.find(
        (ct) => ct.idWorldCardType == c.cardType
      );
      // Get card transactions
      this.transactionsLoading = true;
      try {
        const response = await this.$http.get(
          "settings/load-card?cardId=" + c.idWorldCard
        );
        this.selectedCardTransactions = response.data.transactions;
      } catch (e) {}
      this.transactionsLoading = false;
    },
    closeCard() {
      this.showCardModal = false;
      this.selectedCard = null;
      this.selectedCardType = null;
      this.selectedCardTransactions = [];
    },
    viewTransactions() {
      this.cardModalPage = "transactions";
    },
    openTopUpDialog() {
      this.topUpPrice = this.topUpAmount * this.selectedCard.exchangeRate;
      this.showConfirmTopUp = true;
    },
    async processTopUp(pid) {
      this.showConfirmTopUp = false;
      console.log("topping up with: " + this.topUpAmount);
      const callbackMethod = async () => {
        try {
          const response = await this.$http.post("settings/top-up-card", {
            cardId: this.selectedCard.idWorldCard,
            amount: this.topUpAmount,
          });
          const index = this.cards.findIndex(
            (c) => c.idWorldCard === this.selectedCard.idWorldCard
          );
          this.cards[index] = response.data.card;
          this.selectedCard.balance = response.data.card.balance;
          this.selectedCardTransactions.push(response.data.transaction);
          this.topUpAmount = 1;
          this.topUpPm = 1;
        } catch (e) {}
      };
      if (pid) {
        this.$anm22.anm22_print({
          vue: this,
          printer: pid,
          printMode: "fis",
          // Simulo un prodotto per utilizzare libreria Food
          rows: [
            {
              quantity: 1,
              price: this.topUpPrice,
              elem: {
                productName: "Ricarica tessera",
                productVat: 10,
                variations: [],
              },
            },
          ],
          paymentMethod: this.topUpPm,
          // lotteryCode: this.lotteryData.lotteryCode,
          callbackMethod,
        });
      } else {
        callbackMethod();
      }
    },
    async deleteCard() {
      this.showEditModal = false;
      console.log("deleting card: " + this.selectedCard.idWorldCard);
      const cardId = this.selectedCard.idWorldCard;
      try {
        const response = await this.$http.post("settings/delete-card", {
          cardId: cardId
        });
        if(response.data.success) {
          this.closeCard();
          const index = this.cards.findIndex(
            (c) => c.idWorldCard === cardId
          );
          this.cards.splice(index, 1);
        }
      } catch (e) {}
    },
    loadPrinters() {
      this.printers.forEach((p) => {
        window.createPrinter(p, process.env.VUE_APP_BACK_DOMAIN);
      });
    },
  },
  async created() {
    this.$Progress.start();
    // Blocco l'accesso se ho un permesso di basso livello o se la licenza è una delle demo e il permesso non è superuser
    if (
      !this.accessControl.card ||
      (this.permission !== 1 &&
        (this.license.work === 1 ||
          this.license.work === 2 ||
          this.license.work === 289))
    ) {
      this.$router.push("/").catch((e) => console.log(e));
      return;
    }
    const response = await this.$http.get("settings/cards");
    this.cards = response.data.cards;
    this.cardTypes = response.data.cardTypes;
    await this.$store.dispatch("foodPrinters/update", {
      vlf: this.$vlf("foodPrinters"),
      objs: response.data.printers,
    });
    this.loadPrinters();
    this.$Progress.finish();
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.support-label {
  border: 1px solid #666;
  color: #666;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 4px;
  display: inline;
}
.input-with-label {
  flex-direction: column;
  .icon {
    margin-left: 10px;
  }
  .small {
    width: 200px;
  }
  .label {
    font-size: 16px;
    margin-bottom: 2px;
  }
  input,
  select {
    max-width: 100%;
  }
}
.card-row {
  flex-wrap: nowrap;
  align-items: center;
  padding: 10px 2px;
  border-radius: 5px;
  margin: 2px 0;
  &:hover {
    background-color: #eee;
  }
  & > div {
    padding-right: 5px;
    & > div {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.card-image {
  position: relative;
  width: 100%;
  max-width: 350px;
  border-radius: 12px;
  img {
    width: 100%;
  }
  .btn {
    z-index: 100;
    position: absolute;
    top: 10px;
    right: 10px;
    height: 40px;
    width: 40px;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    background-color: #fff;
    &:hover {
      background-color: #eee;
    }
  }
}
.transaction {
  flex-wrap: nowrap;
  align-items: center;
  padding: 4px;
  // border-radius: 5px;
  border-bottom: 1px solid #ccc;
  .label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.action-btn-with-desc {
  flex-direction: column;
  align-items: center;
  width: 100px;
  text-align: center;
  .btn {
    border-radius: 5px;
    background-color: #eee;
    padding: 10px;
    cursor: pointer;
    height: 80px;
    width: 80px;
    margin: 0 10px;
    &.disabled {
      box-shadow: none;
      pointer-events: none;
      opacity: 0.3;
    }
    &:hover {
      box-shadow: 0 0 0 2px #2196f3;
    }
  }
}
</style>
